import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  tooltip: {
    position: 'absolute',
    top: -35,
    //left: 0,
    backgroundColor: '#333333',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    zIndex: 99999,
    elevation: 99999,
 
    // Ne pas contraindre la largeur au parent (évite que de courts boutons
    // écrasent le texte du tooltip). Laisser une largeur minimale et
    // permettre l'extension jusqu'à une limite raisonnable.
    minWidth: 110,
    maxWidth: 260,
  },

  tooltipText: {
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
  },
});

export default styles;